module.exports = __webpack_public_path__ + "media/images/Branding/HW Word_W-804424ae33a20433bc8e53d186ae834a.png";